var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import merge from "@tinkoff/utils/object/mergeDeep";
import { isBigInt } from "./bigint";
export default function fetchJSON(url_1) {
    return __awaiter(this, arguments, void 0, function* (url, options = {}) {
        options = merge({
            credentials: "same-origin",
            headers: {
                accept: "application/json",
            },
        }, options);
        return window.fetch(url, options).then((res) => {
            if (!res.ok) {
                throw new Error(`HTTP error, status: ${res.status}`);
            }
            return res.text().then((text) => JSON.parse(text, (_, value) => {
                if (isBigInt(value)) {
                    // The back-end can't encode BigInt as number, so we detect BigInt-like strings,
                    // parse them as BigInt, and then convert them back to a numeric string.
                    return BigInt(value.slice(0, -1)).toString();
                }
                return value;
            }));
        });
    });
}
